import { render } from "./visualTable.vue?vue&type=template&id=a12c2c04"
import script from "./visualTable.vue?vue&type=script&lang=js"
export * from "./visualTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__